import Alert from "@mui/material/Alert"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import DialogProvider from "@components/dialog_provider"
import type { LiveChatWidgetRelease } from "@models/live_chat_widget"
import { formatDate } from "@utils/functions/formatDate"

export default function ConfirmRollbackDialog({
  isOpen,
  setClose,
  translate,
  loading,
  release,
  onConfirm
}: {
  isOpen: boolean
  setClose: () => void
  translate: (key: string) => string
  loading: boolean
  release: LiveChatWidgetRelease | null
  onConfirm: () => void
}) {
  return (
    <DialogProvider
      title={translate("live_chat_widget_rollback_title")}
      isOpen={isOpen}
      setClose={setClose}
      size="small"
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("live_chat_widget_rollback"),
        color: "error",
        onClick: onConfirm,
        loading,
        disabled: loading
      }}
    >
      <Stack gap={2}>
        <Alert severity="warning">
          {translate("live_chat_widget_rollback_body")}
        </Alert>
        <Typography variant="body2">
          {release?.version || "—"} ·{" "}
          {release?.createdAt ? formatDate("tr-TR", release.createdAt) : "—"} ·{" "}
          {release?.files?.length ?? 0}{" "}
          {translate("live_chat_widget_file_count")}
        </Typography>
      </Stack>
    </DialogProvider>
  )
}
